// extracted by mini-css-extract-plugin
module.exports = {"strength":"_1Gp9QkN"};